export default "__VITE_ASSET__D4REmV6X__"